import React from 'react';

export default function BudgetPeriod() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Budget Period</h1>
      <p className="text-gray-500">Halaman Budget Period</p>
    </div>
  );
}
